import * as Yup from 'yup'
export const Schema = Yup.object().shape({
    name: Yup.string()
        .max(25, 'نام صندوق باید حداکثر 25 کاراکتر باشد.')
        .required('نام صندوق اجباری می باشد.'),
})
